import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '+34678423475';

const WhatsAppButton = () => {
  const openWhatsApp = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER.replace(/[^0-9]/g, '')}`, '_blank');
  };

  return (
    <button
      onClick={openWhatsApp}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20BD5A] rounded-full shadow-lg flex items-center justify-center text-white transition-all duration-300 hover:scale-110 whatsapp-btn"
      data-testid="whatsapp-floating-button"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle className="h-7 w-7" />
    </button>
  );
};

export default WhatsAppButton;
